import { useState } from "react";
import { bankAccount } from "@/mocks/home";

const steps = [
  {
    id: 1,
    title: "Pilih Program",
    description: "Pilih program kebajikan yang ingin anda sokong daripada senarai program kami.",
    icon: "ri-list-check-3",
  },
  {
    id: 2,
    title: "Buat Pemindahan",
    description: "Pindahkan sumbangan melalui perbankan online atau ATM ke akaun rasmi kami.",
    icon: "ri-bank-line",
  },
  {
    id: 3,
    title: "Kongsi Resit",
    description: "Hantar resit transaksi kepada kami untuk tujuan rekod dan pengesahan yang telus.",
    icon: "ri-file-list-3-line",
  },
];

export default function Donate() {
  const [copied, setCopied] = useState(false);

  const copyAccount = async () => {
    try {
      await navigator.clipboard.writeText(bankAccount.accountNumber.replace(/\s/g, ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section id="sumbangan" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-block text-primary-600 text-sm font-semibold uppercase tracking-wider mb-3">
            Sumbangan
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            Cara Menyumbang
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            Setiap ringgit anda membawa perubahan. Sumbangan anda disalurkan
            secara telus kepada mereka yang memerlukan.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Steps */}
          <div className="w-full lg:w-1/2 space-y-6">
            {steps.map((step) => (
              <div key={step.id} className="flex items-start gap-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-semibold text-lg shrink-0">
                  {step.id}
                </span>
                <div>
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900">
                    {step.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Bank card */}
          <div className="w-full lg:w-1/2">
            <div className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
              <div className="flex items-center gap-3 mb-6">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-bank-line text-xl"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wider">
                    Akaun Rasmi
                  </p>
                  <p className="font-heading font-semibold text-lg text-foreground-900">
                    {bankAccount.bankName}
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <p className="text-xs text-foreground-500 mb-1">Nama Akaun</p>
                  <p className="text-sm md:text-base font-medium text-foreground-900">
                    {bankAccount.accountName}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-foreground-500 mb-1">Nombor Akaun</p>
                  <div className="flex items-center gap-3">
                    <p className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 tracking-wider">
                      {bankAccount.accountNumber}
                    </p>
                    <button
                      type="button"
                      onClick={copyAccount}
                      className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900 cursor-pointer hover:bg-secondary-200 transition-colors"
                      aria-label="Salin nombor akaun"
                    >
                      <i className={`${copied ? "ri-check-line" : "ri-file-copy-line"} text-base`}></i>
                    </button>
                  </div>
                  {copied && (
                    <p className="mt-2 text-xs text-primary-600 font-medium">
                      Nombor akaun telah disalin!
                    </p>
                  )}
                </div>
                <div className="pt-2">
                  <p className="text-xs text-foreground-500 bg-background-50 rounded-md px-4 py-3">
                    <i className="ri-information-line mr-1"></i>
                    {bankAccount.referenceNote}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}